import React, { Fragment, useEffect, useState, useRef } from "react";
import { Input } from '../core/Forms';
import { useApi } from '../../services/api';
import Clipboard from 'clipboard';

const gtag = window && typeof window.gtag === 'function' ? window.gtag : null;

function RecoverInstructions({ recoveryIntent, getRecoveryIntent, recoveryToken }){
	
	const sendTokenOnce = useRef(!!recoveryToken);
	const clipboardButton = useRef();
	const resetPasswordSubmitStatus = useRef(0);

	const [ recoverInstructions, setRecoverInstructions ] = useState();
	
	useEffect( () => {
		if(sendTokenOnce.current === true){
			const recover_instructions = { secret_token: recoveryToken };

			getRecoveryIntent({
				url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
				method: 'PUT',
				data: { recovery_intent: { recover_instructions } } 
			});
		}
	}, [recoveryToken]);

	useEffect( () => {
		if(recoveryIntent.isError){
		}else if(recoveryIntent.isLoading){
			sendTokenOnce.current = false;
		}else if(recoveryIntent.data.recovery_intent.recover_instructions){
			const recoverInstructions = recoveryIntent.data.recovery_intent.recover_instructions;
			
			if(sendTokenOnce.current === false){
				// this should run the first time when there's no recoveryToken, or
				// after the recoveryToken was sent and the data is updated
				setRecoverInstructions(recoverInstructions);

				let screen_name;

				if(!recoverInstructions){
					screen_name = 'loading';
				}else if(!recoverInstructions.token_verified && recoverInstructions.status !== 4){
					if(recoverInstructions.email_sent_at){
						screen_name = 'check_email';
					}else{
						screen_name = 'error';
					}
				}else if(recoverInstructions.show_error){
					screen_name = 'error';
				}else{
					switch(recoverInstructions.status){
						case 1: 
							screen_name = 'confirmation';
							break;
						case 2: 
							screen_name = 'temporary_password';
							break;
						case 3: 
							screen_name = 'reset_password';
							break;
						case 4: 
							screen_name = 'done';
							break;
					}
				}
				
				if(screen_name){
					screen_name = `/recover_instructions/${screen_name}`;
					gtag('event', 'screen_view', { screen_name }); }
			}

			if(resetPasswordSubmitStatus.current === 1){
				resetPasswordSubmitStatus.current = 2; }
		}
	}, [recoveryIntent]);


	useEffect( () => {
		if(!clipboardButton.current){
			return; }

		const clipboard = new Clipboard(clipboardButton.current);

		return () => {
			clipboard.destroy(); }

	});

	function confirm(event){
		const recover_instructions = { secret_token: recoveryToken, accept_confirmation: true };
		
		getRecoveryIntent({
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent: { recover_instructions } } 
		});
	}

	function submitResetPassword(event){
		event.preventDefault();

		const recover_instructions = { secret_token: recoveryToken };

		recover_instructions.password = event.target['password'].value;
		recover_instructions.password_confirmation = event.target['password_confirmation'].value;

		getRecoveryIntent({
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent: { recover_instructions } } 
		});

		resetPasswordSubmitStatus.current = 1;

		return false;
	}

	if(!recoverInstructions){
		return (<div className="progress">
			<div className="progress-bar progress-bar-striped progress-bar-animated w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
		</div>);
	}

	if(!recoverInstructions.token_verified && recoverInstructions.status !== 4){
		if(recoverInstructions.email_sent_at){
			return (<div className="jumbotron border-bottom">
				<h3>Revisa tu correo electrónico</h3>
				<hr className="my-4" />
				<p>Hemos enviado un enlace a tu correo personal para que verifiquemos tu identidad.</p>
				<p>Si no tienes acceso a ese correo, intenta nuevamente o acude a tu Institución para restaurar tu acceso.</p>
				<div className="d-flex justify-content-center justify-content-md-start">
					<a className="btn btn-dark btn-lg" href="/login" role="button">Ir a Saeko</a>
				</div>
			</div>);
		}else{
			return (<div className="jumbotron border-bottom">
				<h3 className="text-center">Ups, tenemos un problema</h3>
				<hr className="my-4" />
				<p className="text-danger text-center">{recoverInstructions.show_message ?
					recoverInstructions.show_message : 'Esta sesión ha caducado, vuelve a iniciar'}</p>
				<div className="d-flex justify-content-center">
					<a className="btn btn-outline-danger" href='/forgot_password'>Reiniciar</a>
				</div>
			</div>);
		}
	}

	if(recoverInstructions.show_error){
		return (<div className="jumbotron border-bottom">
			<h3 className="text-center">Ups, tenemos un problema</h3>
			<hr className="my-4" />
			<p className="text-danger text-center">{recoverInstructions.show_error}</p>
			<div className="d-flex justify-content-center">
				<a className="btn btn-outline-danger" href='/forgot_password'>Reiniciar</a>
			</div>
		</div>);
	}


	switch(recoverInstructions.status){
		case 1:
			return (<div className="jumbotron border-bottom">
				<h3>¡Confirmado!</h3>
				<hr className="my-4" />
				<p>{recoverInstructions.show_message}</p>
				<div className="d-flex justify-content-center justify-content-md-start">
					<button className="btn btn-primary btn-lg" onClick={confirm} disabled={recoveryIntent.isLoading}>
						{recoveryIntent.isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
						Continuar
					</button>
				</div>
			</div>);
			

		case 2:
			return (<div className="jumbotron border-bottom">
				<h3>¡Reinicio Exitoso!</h3>
				<hr className="my-4" />
				<p>{recoverInstructions.show_message}</p>
				<h3 className="text-success"><center>{recoverInstructions.temporary_password}</center></h3>
				<div className="d-flex justify-content-center">
					<a ref={clipboardButton} data-clipboard-text={recoverInstructions.temporary_password} className="btn btn-outline-success" href={recoverInstructions.external_reset_link}>Copiar y continuar...</a>
				</div>
			</div>);
			

		case 3:
			let passwordValid;
			if(recoverInstructions.show_message && resetPasswordSubmitStatus.current === 2){
				passwordValid = false; }

			return (<Fragment>
				<h2>Crea una nueva contraseña</h2>
				<p className="text-muted">Escribe una nueva contraseña de mínimo 8 letras; puedes usar números y símbolos a tu gusto.</p>

				<form onSubmit={submitResetPassword}>
					
					<Input name="password" label="Contraseña" type="password"
						invalidFeedback={recoverInstructions.show_message}
						isValid={passwordValid}
						autoComplete="new-password" />
					
					<Input name="password_confirmation" label="Contraseña nuevamente" type="password"
						isValid={passwordValid}
						autoComplete="new-password" />
					
					<button type="submit" className="btn btn-primary w-100" disabled={recoveryIntent.isLoading}>
						{recoveryIntent.isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
						Guardar
					</button>
				</form>
			</Fragment>);

		case 4:
			return (<div className="jumbotron border-bottom">
				<h3 className="text-center">¡Acceso Restaurado!</h3>
				<hr className="my-4" />
				<p className="text-center">Listo, hemos completado el proceso de recuperación de contraseña.</p>
				<div className="d-flex justify-content-center">
					<a className="btn btn-success btn-lg w-100" href="/login" role="button">Iniciar sesión</a>
				</div>
			</div>);
		
		default:
			return (<Fragment/>);		
	}


}

export default RecoverInstructions;
